import AxiosInterceptor from "../../AxiosInterceptorMomthera";

// 어플 사용자 조회
// 환자가 한 명도 없는 경우 500에러로 반환됨.
export function getMomtheraDashboardPatientGroup() {
    return AxiosInterceptor({
        url: '/dashboard/patient-group',
        method: 'get'
    })
}

// 어플 사용 현황 조회
export function getMomtheraDashboardTraining() {
    return AxiosInterceptor({
        url: '/dashboard/training',
        method: 'get'
    })
}